import { render } from "./JobRunsView.vue?vue&type=template&id=f1339eb4&scoped=true&ts=true"
import script from "./JobRunsView.vue?vue&type=script&lang=ts"
export * from "./JobRunsView.vue?vue&type=script&lang=ts"

import "./JobRunsView.vue?vue&type=style&index=0&id=f1339eb4&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1339eb4"]])

export default __exports__